import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { BatchImportRepository } from '@data-layer/repositories';
import { finalize, takeUntil } from 'rxjs/operators';
import { DocumentsService } from '@services/documents.service';
import { CompaniesService } from '@services/companies.service';
import { ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'isf-batch-sidebar',
  templateUrl: './isf-batch-sidebar.component.html',
  styleUrls: ['./isf-batch-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IsfBatchSidebarComponent implements OnInit, OnDestroy {
  @Input() public batchId: number;
  @Output() public onCreated: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('link', { static: false }) public linkRef: ElementRef;

  public autoConfirmFc: UntypedFormControl;
  public uploadedFile: File;
  public isLoading: boolean;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(
    private batchImportRepository: BatchImportRepository,
    private documentsService: DocumentsService,
    private companiesService: CompaniesService,
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    this.autoConfirmFc = new UntypedFormControl(false);
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public create(): void {
    this.isLoading = true;

    this.batchImportRepository
      .importIsf(this.companiesService.getCompany()?.id, this.uploadedFile, this.batchId)
      .pipe(
        finalize(() => (this.isLoading = false)),
        takeUntil(this.destroy$),
      )
      .subscribe((batchId: number) => {
        if (this.autoConfirmFc.value) {
          this.router.navigate(['/', 'isf', 'batch', batchId, 'loading'], { queryParams: { isAfterUpload: true, isConfirmed: true } });
        } else {
          this.router.navigate(['/', 'isf', 'batch', batchId, 'loading'], { queryParams: { isAfterUpload: true } });
        }

        this.onCreated.emit();
      });
  }

  public onUploadFile(file: File): void {
    this.uploadedFile = file;
  }

  public onRemoveFile(): void {
    this.uploadedFile = null;
  }

  public downloadSample(): void {
    this.isLoading = true;

    this.batchImportRepository
      .getIsfTemplate()
      .pipe(
        finalize(() => (this.isLoading = false)),
        takeUntil(this.destroy$),
      )
      .subscribe((file: Blob) => {
        this.documentsService.downloadBlobFile(file, 'isf_template.xlsx');

        this.cdr.markForCheck();
      });
  }
}
